import { FormControl, AbstractControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

export function debounce(formControl: FormControl | AbstractControl, callback: CallableFunction): void {
    formControl.valueChanges.pipe(debounceTime(1000), distinctUntilChanged()).subscribe(query => {
        callback(query);
    });
}
